import React, { useContext, memo } from "react";
import clsx from "clsx";

import { Skeleton, RequiredMark } from "components";
import { ApplicationEntryProgressContext } from "components/contexts";
import { generateAutotestValue } from "helpers";

import { RequiredMarkContext } from "../contexts/requiredMarkContext";

import styles from "./checkButtonValid.module.scss";

const CheckButton = ({
	label,
	id,
	className,
	labelClassName,
	wrapperClassName,
	input,
	meta: { touched, error, warning },
	disabled,
	tabIndex,
	role,
	blurLoading,
	skeletonWidth,
	skeletonMarginTop,
	skeletonMarginBottom,
	hideRequiredMark, //works only with RequiredMarkContext
	autoTest = "",
}) => {
	const showRequiredMark =
		useContext(RequiredMarkContext) && !hideRequiredMark && !disabled;
	const { triggerSave } = useContext(ApplicationEntryProgressContext);

	const handleBlur = () => {
		input.onBlur(input.value);
		triggerSave?.();
	};

	let disabledStyle = disabled ? styles.disabled : null;
	const checkRoleDisabled = role === "cdSetupDisabled" ? null : disabledStyle;

	const hasError = touched && error && (
		<p className={styles.spanError}>{error}</p>
	);

	const hasWarning = warning && (
		<p className={`${styles.spanError} ${styles.spanWarn} pt-1`}>
			{warning}
		</p>
	);

	const labelBlock = label ? (
		<label htmlFor={id} className={clsx(checkRoleDisabled, labelClassName)}>
			{label}
			{showRequiredMark && <RequiredMark />}
		</label>
	) : null;

	const autotestValue = generateAutotestValue(autoTest, input.name);
	const dataAutotest = `checkboxContainer${autotestValue}`;

	return blurLoading ? (
		<Skeleton
			variant="text"
			width={skeletonWidth}
			marginTop={skeletonMarginTop}
			marginBottom={skeletonMarginBottom}
		/>
	) : (
		<div
			className={clsx(styles.wrappCheckButtonValid, wrapperClassName)}
			data-autotest={dataAutotest}
		>
			<div className={className}>
				<input
					type="checkbox"
					{...input}
					onBlur={handleBlur}
					id={id}
					checked={input.value}
					tabIndex={tabIndex}
					disabled={disabled}
				/>
				{labelBlock}
			</div>
			{hasError}
			{hasWarning}
		</div>
	);
};

export default memo(CheckButton);
